// extracted by mini-css-extract-plugin
export default {"lds_circle":"Loading_lds_circle__I-ozI","lds-circle":"Loading_lds-circle__QM9Ba"};